/* eslint-disable @typescript-eslint/no-unused-vars */
import { Response } from 'miragejs';
import {
  BANK_ACCOUNT_URL,
  FIRST_STEPS_URL,
  GET_VIACEP_BY_CEP,
  INVITE_SIGNUP_API_URL,
  PERSONAL_INFORMATION_API_URL,
  SELLER_TAGS_URL,
  UNLEASH_EXPERIMENT_URL,
  URL_COMPANY_INFO,
  URL_LIABLE_PARTNER,
  URL_LOGISTIC_ADDRESS,
  URL_SUBSCRIPTION_PLAN_OPTIONS,
  URL_SUBSCRIPTION_PLAN_V2_CHOICE,
  WHO_AM_I_URL,
} from 'utils/api-urls';

import {
  FIRST_STEPS_MOCK,
  INVITE_MOCK,
  PERSONAL_INFORMATIONS_MOCK,
  PLANS_CHOISE_V2_MOCK,
  PLAN_OPTIONS_MOCK,
  SELLER_TAGS_MOCK,
  VIA_CEP_MOCK,
  WHO_AM_I_MOCK,
} from './onboarding.mock';

export default function onboardingRoutes(server) {
  server.get(WHO_AM_I_URL, () => new Response(200, {}, WHO_AM_I_MOCK));
  server.get(FIRST_STEPS_URL, () => new Response(200, {}, FIRST_STEPS_MOCK));
  server.get(PERSONAL_INFORMATION_API_URL, () => new Response(200, {}, PERSONAL_INFORMATIONS_MOCK));
  server.get(GET_VIACEP_BY_CEP, () => new Response(200, {}, VIA_CEP_MOCK));
  server.get(SELLER_TAGS_URL, () => new Response(200, {}, SELLER_TAGS_MOCK));
  server.get(URL_SUBSCRIPTION_PLAN_V2_CHOICE, () => new Response(200, {}, PLANS_CHOISE_V2_MOCK));
  server.get(URL_SUBSCRIPTION_PLAN_OPTIONS, () => new Response(200, {}, PLAN_OPTIONS_MOCK));
  server.get(`${INVITE_SIGNUP_API_URL}/:code`, () => new Response(200, {}, INVITE_MOCK));
  server.post(URL_LOGISTIC_ADDRESS, () => new Response(200, {}, {}));
  server.post(URL_COMPANY_INFO, () => new Response(200, {}, {}));
  server.post(URL_LIABLE_PARTNER, () => new Response(200, {}, {}));
  server.post(BANK_ACCOUNT_URL, () => new Response(200, {}, {}));
  server.post(
    INVITE_SIGNUP_API_URL,
    () =>
      new Response(
        409,
        {},
        {
          statusCode: 409,
          timestamp: '2022-08-22T19:56:43.995Z',
          path: '/bff/acquisition/v1/invites',
          message: 'Http Exception',
        }
      )
  );
  server.get(UNLEASH_EXPERIMENT_URL('conversion_payment'), () => new Response(200, {}, true));
}
